"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulatorProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _modal = require("@creditas-lab/modal");

var _contexts = require("./contexts");

var _constants = require("./constants");

var _Simulator = require("./Simulator");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   Interest rate type to get simulations. It must be `MINIMUM` or `AVERAGE`.
  */
  interestRateType: (0, _propTypes.oneOf)([_constants.InterestRateTypes.MINIMUM, _constants.InterestRateTypes.AVERAGE]),

  /**
   The display content of the provider.
  */
  children: _propTypes.node.isRequired,
  overrideRedirectToAuto: _propTypes.func,
  overrideRedirectToHome: _propTypes.func
} : {};
const defaultProps = {
  interestRateType: _constants.InterestRateTypes.MINIMUM
};

const SimulatorProvider = ({
  interestRateType,
  children,
  overrideRedirectToAuto,
  overrideRedirectToHome
}) => {
  const [intendedCredit, setIntendedCredit] = (0, _react.useState)(0);
  const [productType, setProductType] = (0, _react.useState)('');
  const {
    open,
    openModal,
    closeModal
  } = (0, _modal.useModalState)();
  const contextProps = {
    interestRateType,
    openSimulator: openModal,
    closeSimulator: closeModal,
    intendedCredit,
    setIntendedCredit,
    productType,
    setProductType,
    overrideRedirectToAuto,
    overrideRedirectToHome
  };
  return (0, _core.jsx)(_contexts.SimulatorContext.Provider, {
    value: contextProps
  }, (0, _core.jsx)(_Simulator.Simulator, {
    open: open
  }), children);
};

exports.SimulatorProvider = SimulatorProvider;
process.env.NODE_ENV !== "production" ? SimulatorProvider.propTypes = propTypes : void 0;
SimulatorProvider.defaultProps = defaultProps;
SimulatorProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SimulatorProvider",
  "props": {
    "interestRateType": {
      "defaultValue": {
        "value": "InterestRateTypes.MINIMUM",
        "computed": true
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "InterestRateTypes.MINIMUM",
          "computed": true
        }, {
          "value": "InterestRateTypes.AVERAGE",
          "computed": true
        }]
      },
      "required": false,
      "description": "Interest rate type to get simulations. It must be `MINIMUM` or `AVERAGE`."
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "The display content of the provider."
    },
    "overrideRedirectToAuto": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "overrideRedirectToHome": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};